import React, { Component } from 'react';
import {Link} from 'react-router'
import './HomeSignUpBanner.scss';

class HomeSignUpBanner extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        return (
            <div className='home-sign-up-banner'>
              <div className="container">
                <div className='row'>
                  <div className='col-sm-9'>
                    <h3 className=''>{this.props.title}</h3>
                    <p>{this.props.description}</p>
                  </div>
                  <div className='col-sm-3'>
                    <Link to='register' className="btn btn-success btn-lg btn-block">{this.props.cta}</Link>
                  </div>
                </div>
              </div>
            </div>
        )
    }
}

export default HomeSignUpBanner;



// WEBPACK FOOTER //
// ./src/views/pages/Home2/HomeSignUpBanner/index.js